<div class='users-component' style='height: 100%'>
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">



    <div style="display: flex; flex-direction: row; margin-top: 16px;">
      <form class="example-form">
        <button mat-raised-button
                (click)="editTenantPermissions(null)"
                style="border-radius: 6px; margin-right: 10px;">
          Add Edition
        </button>
      </form>
    </div>
  </div>

  <p-table [value]="tenantPermissions"
           [rows]="100"
           [paginator]="true"
           [style]="{'margin-top':'10px'}"
           #table
           dataKey="roleGroup"
  >
    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;font-weight: bold">
        <th *ngFor="let col of cols" [ngStyle]="{'width': col.width || 'auto'}">
          {{col.header}}
        </th>
        <th style="width: 5em;">Default</th>
        <th>Link</th>
        <th style="width:15em"></th>
      </tr>
      <tr>
        <th *ngFor="let col of cols">
          <input pInputText type="text" placeholder="⌕"
                 (input)="table.filter($event.target['value'], col.field, 'contains')">
        </th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="item">
        <td *ngFor="let col of cols"  [ngSwitch]="col.field">
          <span>{{item[col.field]}}</span>
        </td>
        <td><mat-radio-button name="default" [value]="item.tenantPermissionsId" (change)="setDefault(item.tenantPermissionsId)" [checked]="item.tenantPermissionsId == defaultTenantPermissionsId"></mat-radio-button></td>
        <td><a [href]="'https://app.' + host + '/createAccount/' + item.secret" target="_blank">{{'https://app.' + host + '/createAccount/' + item.secret}}</a></td>
        <td>
          <button type="button"
                  pButton
                  class="risksponge-button"
                  (click)="editTenantPermissions(item.tenantPermissionsId)"
                  title="Edit edition"
                  icon="pi pi-pencil">
          </button>
          <button type="button"
                  pButton
                  class="risksponge-button"
                  title="Delete edition"
                  icon="pi pi-trash"
                  mwlConfirmationPopover
                  [title]="'Delete edition'" [popoverMessage]="'You are going to delete this edition. Are you sure?'"
                  [appendToBody]="true"
                  [confirmText]="'Yes'" [cancelText]="'No'" placement="top" (confirm)="deleteTenantPermissions(item.tenantPermissionsId)">
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="msg" role="alert" class="alert alert-info alert-dismissible">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span>
    </button>
    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
    <span class="sr-only">Error:</span>
    {{msg}}
  </div>
</div>
